import { createFileRoute, redirect } from "@tanstack/react-router"

// Consolidated into the tabbed Reports page (Guests → Reports).
export const Route = createFileRoute("/$orgSlug/$eventSlug/accommodations")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$orgSlug/$eventSlug/reports",
      params,
      search: { tab: "accommodations" },
    })
  },
})
